export default "__VITE_ASSET__Cbi8YVJa__"